import moment from "moment";
const HelperService = {
  allowOnlyNumericValue(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }

    if (e.currentTarget.value.length > 11) {
      e.preventDefault();
      return false;
    }
  },
  allowOnlyDigits(e: any) {
    var numbers = /^[0-9]$/;
    if (!e.key.match(numbers) && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }
  },
  getFormatedValue(value: any) {
    var numbers = value.replaceAll("+", " ");
    numbers = numbers.replaceAll("%2A", "*");
    return numbers;
  },
  allowOnlyCharacterValue(e: any) {
    var re = /^[A-Za-z/s]+/;
    if (!e.key.match(re) && e.charCode !== 32) {
      e.preventDefault();
      return false;
    }
  },

  /* number -> words (Indian numbering: Crore / Lakh / Thousand) with paise;
     e.g. 500.15 -> "Five Hundred Rupees and Fifteen Paise Only". Returns "" for
     empty/NaN. The decimal part is kept and read as paise (rounded to 2 dp). */
  amountToWords(input: any): string {
    // keep digits AND the decimal point (strip commas / currency symbols / etc.)
    const cleaned = String(input ?? "").replace(/[^0-9.]/g, "");
    if (!cleaned || cleaned === ".") return "";
    const value = parseFloat(cleaned);
    if (isNaN(value)) return "";
    // work in integer paise to avoid float drift and to split rupees / paise
    const totalPaise = Math.round(value * 100);
    const rupees = Math.floor(totalPaise / 100);
    const paise = totalPaise % 100;

    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const two = (n: number): string => (n < 20 ? ones[n] : tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : ""));
    const three = (n: number): string => (n >= 100 ? ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + two(n % 100) : "") : two(n));
    const inWords = (num: number): string => {
      if (num === 0) return "";
      let n = num;
      const crore = Math.floor(n / 10000000);
      n %= 10000000;
      const lakh = Math.floor(n / 100000);
      n %= 100000;
      const thousand = Math.floor(n / 1000);
      n %= 1000;
      const rest = n;
      const parts: string[] = [];
      if (crore) parts.push(three(crore) + " Crore");
      if (lakh) parts.push(two(lakh) + " Lakh");
      if (thousand) parts.push(two(thousand) + " Thousand");
      if (rest) parts.push(three(rest));
      return parts.join(" ").trim();
    };

    const rupeeWords = inWords(rupees);
    const paiseWords = paise ? two(paise) : "";

    const segs: string[] = [];
    if (rupeeWords) segs.push(rupeeWords + " Rupees");
    if (paiseWords) segs.push(paiseWords + " Paise");
    if (segs.length === 0) return "Zero Rupees Only";
    return segs.join(" and ") + " Only";
  },

  calculateBMI(weight: any, height: any) {
    var bmi: any = (weight / ((height * height) / 10000)).toFixed(2);
    return Math.round(bmi);
  },

  getFormatedDate(d: any) {
    return d && d !== "0000-00-00" ? moment.utc(d).format("MM/DD/YY") : "NA";
  },

  getNewFormatedDate(d: any) {
    return d && d !== "0000-00-00" ? moment.utc(d).format("YYYY-MM-DD") : "NA";
  },

  getFormatedDateByDMY(d: any) {
    return d && d !== "0000-00-00" ? moment(d).format("DD-MMM-YYYY") : "NA";
  },
  getFormatDateByDMY(d: any) {
    return d && d !== "0000-00-00" ? moment(d).format("DD-MMM-YY") : "NA";
  },

  getFormatedDateByDMYwith(d: any) {
    return d && d !== "0000-00-00 00:00:00"
      ? moment(d).format("DD-MMM-YYYY")
      : "NA";
  },
  getFormatedDateByDMYNew(d: any) {
    return d && d !== "0000-00-00"
      ? moment(d, "DD-MM-YYYY").isValid()
        ? moment(d, "DD-MM-YYYY").format("DD-MMM-YYYY")
        : "NA"
      : "NA";
  },
  getFormatedMonthYear(d: any) {
    return d && d !== "0000-00-00 00:00:00"
      ? moment(d).format("MMMM-YYYY") // Format as "2024-August"
      : "NA";
  },

  getCurrencyFormatter: function (e: any) {
    if (e || e === 0) {
      return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(e);
    } else {
      return e;
    }
  },
  getCurrencyFormatterForDecimal: function (e: any) {
    if (e || e === 0) {
      return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 4,
        minimumFractionDigits: 4,
      }).format(e);
    } else {
      return e;
    }
  },

  getFormatedDateAndTime(dt: any) {
    return dt && dt !== "0000-00-00 00:00:00"
      ? moment.utc(dt).format("DD-MMM-YYYY, hh:mm:ss A")
      : "NA";
  },

  getCurrencyFormatterWithoutDecimal: function (e: any) {
    if (e || e === 0) {
      e = Math.floor(e);
      return new Intl.NumberFormat("en-IN").format(e);
    } else {
      return e;
    }
  },

  formatAmount: function (e: any) {
    if (e > 0) {
      var numb = e.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      return numb;
    } else {
      return "";
    }
  },

  currencyFormat: function (e: any) {
    e.currentTarget.value = this.formatAmount(
      e.currentTarget.value ? e.currentTarget.value.replaceAll(",", "") : ""
    );
  },

  getRoundOff: function (num: number) {
    return Math.round(num);
  },

  maxNumber(e: any, maxNumber: number) {
    if (maxNumber && e.currentTarget.value.length > maxNumber) {
      e.preventDefault();
      return false;
    }
  },

  titleCase(str: any) {
    var splitStr = str.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  },

  startsWithCapital(word: any) {
    if (word.charAt(1) === word.charAt(1).toUpperCase()) {
      return word;
    } else {
      var splitStr = word.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    }
  },
  isValidEmail(email: string) {
    let strRegex = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
    return email ? strRegex.test(email) : true;
  },

  isValidurlPatternValidation(URL: any) {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
    );
    return URL ? regex.test(URL) : true;
  },

  isValidPan(pan: any) {
    let strRegex = new RegExp(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
    return pan ? strRegex.test(pan) : true;
  },

  getRomanNumber(num: number) {
    if (isNaN(num)) return NaN;
    var digits: any = String(+num).split(""),
      key: any = [
        "",
        "C",
        "CC",
        "CCC",
        "CD",
        "D",
        "DC",
        "DCC",
        "DCCC",
        "CM",
        "",
        "X",
        "XX",
        "XXX",
        "XL",
        "L",
        "LX",
        "LXX",
        "LXXX",
        "XC",
        "",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
      ],
      roman = "",
      i = 3;
    while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
    return Array(+digits.join("") + 1).join("M") + roman;
  },

  //     pancardValidation (ObjVal:any){
  //       var Obj :any = document.getElementById("textPanNo");
  //       if (Obj?.value != "") {
  //           ObjVal = Obj?.value;
  //           var panPat = /^([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$/;
  //           if (ObjVal.search(panPat) == -1) {
  //               alert("Invalid Pan No");
  //               Obj.focus();
  //               return false;
  //           }
  //         else
  //           {
  //             alert("Correct Pan No");
  //             }
  //       }
  // },
  getFormattedContact: function (e: any) {
    if (e) {
      const match = e.replace(/\D+/g, "");
      const part1 = match.length > 2 ? `${match.substring(0, 3)}` : match;
      const part2 = match.length > 3 ? `-${match.substring(3, 6)}` : "";
      const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : "";
      var x = part1 + "" + part2 + "" + part3;
      return x;
    } else {
      return e;
    }
  },

  ValidEmail(email: string) {
    return email
      ? /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
      : true;
  },

  convertTime(timeStr: any) {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours == "12") {
      hours = "00";
    }
    if (modifier == "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  },

  getText(text: any, length: any) {
    if (text && length && text.length > length) {
      return text.substring(0, length) + "...";
    }

    return text;
  },

  removeAMPM(timeStr: string) {
    if (timeStr) {
      let time = timeStr;
      time.replaceAll("PM", "");
      time.replaceAll("AM", "");
      return time;
    }
  },
  convertTime12to24(time12h: any) {
    const [time, modifier] = time12h.split(" ");

    let [hours, minutes] = time.split(":");

    if (hours === "12") {
      hours = "00";
    }

    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  },

  tConvert(time: any) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  },

  // ValidatePAN(value: any) {
  //   var txtPANCard = document.getElementById("txtPANCard");
  //   var lblPANCard = document.getElementById("lblPANCard")
  //   var regex = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
  //   if (regex.test(value.toUpperCase())) {
  //   } else {
  //     return false;
  //   }
  // }

  sorting(sortBy: any, id: any) {
    var orderBy = "ASC";
    var className = "sorting_asc";
    var temp = document.getElementById(id);
    if (temp) {
      if (temp.className.includes("sorting_asc")) {
        className = "sorting_desc";
      }
      var oldSorting = document.getElementsByClassName("sorting_asc");
      if (oldSorting.length > 0) {
        oldSorting[0].classList.remove("sorting_asc");
      } else {
        oldSorting = document.getElementsByClassName("sorting_desc");
        if (oldSorting.length > 0) {
          oldSorting[0].classList.remove("sorting_desc");
        }
      }
      if (className == "sorting_asc") {
        temp.classList.add("sorting_asc");
        temp.classList.remove("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        temp.classList.add("sorting_desc");
        temp.classList.remove("sorting_asc");
        orderBy = "DESC";
      }
    }
    var obj = {
      order_by: orderBy,
      sort_by: sortBy,
    };
    return obj;
  },

  allowNewDecimalValue(e: any) {
    let keyCode = e.keyCode ? e.keyCode : e.which;
    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode != 46 || e.target.value.indexOf(".") != -1)
    ) {
      e.preventDefault();
      return false;
    }
    if (
      e.target.value != null &&
      e.target.value.indexOf(".") > -1 &&
      e.target.value.split(".")[1].length > 3 &&
      (e.target.selectionStart == e.target.value.length ||
        e.target.selectionStart == e.target.value.length - 1 ||
        e.target.selectionStart == e.target.value.length - 2)
    ) {
      e.preventDefault();
      return false;
    }
  },
  monthDiff(d1: any, d2: any) {
    const start_date = new Date(d1);
    const end_date = new Date(d2);
    var months;
    months = (end_date.getFullYear() - start_date.getFullYear()) * 12;
    months -= start_date.getMonth();
    months += end_date.getMonth();
    return months <= 0 ? 0 : months;
  },
  monthDiffNew(d1: any, d2: any) {
    const start_date = new Date(d1);
    const end_date = new Date(d2);
    const yearDiff = end_date.getFullYear() - start_date.getFullYear();
    const monthDiff = end_date.getMonth() - start_date.getMonth();
    const dayDiff = end_date.getDate() - start_date.getDate();
    let totalMonths = yearDiff * 12 + monthDiff;
    if (dayDiff !== 0) {
      const daysInMonth = new Date(
        end_date.getFullYear(),
        end_date.getMonth() + 1,
        0
      ).getDate();
      totalMonths += dayDiff / daysInMonth;
    }
    return totalMonths <= 0 ? 0 : totalMonths;
  },
  formatDate(inputDate: any) {
    const parts = inputDate.split("-");
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    const date = new Date(`${month}/${day}/${year}`);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthName = monthNames[date.getMonth()];
    const formattedDate = `${day}-${monthName}-${year}`;
    return formattedDate;
  },
  //Function to get Current financial year
  GetCurrentFinancial() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    let startYear, endYear;

    if (month < 4) {
      startYear = year - 1;
      endYear = year;
    } else {
      startYear = year;
      endYear = year + 1;
    }

    return `FY ${startYear}-${String(endYear).slice(-2)}`;
  },
  allowOnlyNumericDecimalValue(e: any) {
    const key = e.key;
    const value = e.currentTarget.value;

    // Allow: backspace, delete, arrows, tab, home, end
    if (
      [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ].includes(key)
    ) {
      return;
    }

    // Allow: one decimal point
    if (key === ".") {
      if (value.includes(".")) {
        e.preventDefault();
        return false;
      }
      return;
    }

    // Allow: digits
    if (!/^[0-9]$/.test(key)) {
      e.preventDefault();
      return false;
    }

    // Optional: restrict length (excluding decimal)
    if (value.replace(".", "").length >= 11) {
      e.preventDefault();
      return false;
    }
  },

  getValueWithoutComma: function (value: any) {
    if (!value) return 0;
    return Number(value.toString().replaceAll(",", ""));
  },


  roundToNearestThousand(value:any) {
    const num = this.getValueWithoutComma(value) || 0;
    if (num <= 0) return 0;
    return Math.max(1000, Math.round(num / 1000) * 1000);
  }
};
export default HelperService;
